module.exports = __webpack_public_path__ + "img/loginast.a652a696.png";